module.exports = __webpack_public_path__ + "img/rope-brick-wall-painting.39d17a01.jpg";